import {
  EducatorsWorkspacesInvitation,
  EducatorsWorkspacesReliefListingRequest,
  EducatorsWorkspacesTeacher,
  SharedLearnerReliefListingRequestFacade,
} from "@/types/serializers"
import { useProps } from "@/lib/page-rendering"

export type ShowProps = {
  teacher: EducatorsWorkspacesTeacher
  team_invitations: Array<EducatorsWorkspacesInvitation>
  learner_relief_requests: Array<SharedLearnerReliefListingRequestFacade>
  educator_relief_requests: Array<EducatorsWorkspacesReliefListingRequest>
}

export const useShowProps = () => useProps<ShowProps>()
